import { Heading } from '@efdigital/ll-addon-ui';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface SettingsSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Settings"}}
  <div class="container py-3 px-3">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-11 col-xxl-10">
        <Heading
          @size="md"
          @text="Settings"
          @secondary="Manage your coach profile, notification preferences, and account settings."
          @class="mb-4"
        />

        <div class="mb-4">
          <ul
            class="nav nav-pills nav-fill coaching-dashboard-coach-tabs bg-body rounded-pill p-1 shadow-sm w-100 flex-nowrap"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <LinkTo
                @route="coaching.coach.settings.index"
                class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center w-100"
                role="tab"
              >
                Profile
              </LinkTo>
            </li>
            <li class="nav-item" role="presentation">
              <LinkTo
                @route="coaching.coach.settings.availability"
                class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center w-100"
                role="tab"
              >
                Availability
              </LinkTo>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  {{outlet}}
</template> satisfies TOC<SettingsSignature>;
